import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicModule} from 'ionic-angular';
import { CustomLoadingComponent } from './custom-loading';

@NgModule({
  declarations: [
    CustomLoadingComponent,
  ],
  imports: [
    IonicModule
  ],
  exports: [
    CustomLoadingComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class CustomLoadingComponentModule {}



// WEBPACK FOOTER //
// ./src/components/custom-loading/custom-loading.module.ts